import React from "react";

const TestimonilaBlock: React.FC = () => {
    return (
        <section className="px-5 py-16" style={{ background: "linear-gradient(94.66deg, #3760DD 48.41%, #1B48D0 99.63%)" }}>
            <p className="text-white font-normal text-2xl text-center md:w-7/12 mx-auto">
                Incredible support by the team, we are really delighted to be among the first 100 users and still be in the active users list
            </p>
            <div className="flex gap-2 items-center mx-auto w-fit pt-7">
                <div className="w-12 h-12 rounded-full">
                    <img src="/person.svg" alt="" className="w-full rounded-full w-12" />
                </div>
                <div>
                    <p className="text-white font-bold text-xl uppercase">PRAVEEN M</p>
                    <p className="text-white font-normal tex-lg">Vice President Sales</p>
                </div>
            </div>
        </section>
    );
};
export default TestimonilaBlock;
